import React from 'react';
import { problemCards } from '../data/landing';
import { AnimatedSection } from './AnimatedSection';
export function ProblemSection() {
  return <>
      <section className="bg-white py-20 sm:py-24" data-id="element-181" data-mp="2lq8hqrnk5uhb">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-182" data-mp="30hhgbq9fuq6l">
          <AnimatedSection data-id="element-183" data-mp="2vqhhgfgrdy1g">
            <h2 className="max-w-3xl text-3xl font-semibold tracking-[-0.02em] text-gray-950 sm:text-4xl" data-id="element-184" data-mp="2vq7msekrr2pf">
              Your booth should not be your prospecting strategy.
            </h2>
            <div className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-gray-200 bg-gray-200 md:grid-cols-3" data-id="element-185" data-mp="35gtzo113pf4f">
              {problemCards.map((problem, index) => <article key={problem} className="min-h-48 bg-white p-7 sm:p-8" data-id="element-186" data-mp="3eh8ld1hz8w8g" data-mpi={index}>
                  <span className="font-mono text-sm font-bold tabular-nums text-indigo-600" data-id="element-187" data-mp="3ef5zmtnuxp9j">0{index + 1}</span>
                  <p className="mt-8 text-xl font-bold leading-7 text-gray-900" data-id="element-188" data-mp="1k2xz90srog6d">{problem}</p>
                </article>)}
            </div>
            <p className="mt-8 border-l-4 border-indigo-600 pl-5 text-lg font-bold text-gray-900" data-id="element-189" data-mp="jeetatcxvtl6">
              The conference starts weeks before anyone walks onto the floor.
            </p>
          </AnimatedSection>
        </div>
      </section>

      <section className="border-y border-gray-200 bg-gray-950 py-20 text-white sm:py-24" data-id="element-190" data-mp="x4i9b2l86r26">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_420px] lg:gap-20 lg:px-8" data-id="element-191" data-mp="123ldylxamv9m">
          <AnimatedSection data-id="element-192" data-mp="1726b2ch90ytu">
            <h2 className="max-w-3xl text-3xl font-semibold tracking-[-0.02em] sm:text-4xl" data-id="element-193" data-mp="171elbiac1vbh">
              We work the attendee universe before your reps arrive.
            </h2>
            <p className="mt-6 max-w-3xl text-lg leading-8 text-gray-300" data-id="element-194" data-mp="1g3noto76oofd">
              Turnout identifies likely attendees, prioritizes the accounts that
              fit, starts the conversation, and schedules qualified meetings.
              Your team lands with a calendar instead of a cold list.
            </p>
          </AnimatedSection>
          <AnimatedSection delay={0.08} data-id="element-195" data-mp="p2d4e7suq5ea">
            <div className="overflow-hidden rounded-xl border border-gray-700 bg-gray-900" data-id="element-196" data-mp="k1z4xe5bg3rv">
              <div className="border-b border-gray-700 px-6 py-4" data-id="element-197" data-mp="y1gnvcvxkmtb"><p className="text-sm font-bold text-gray-300" data-id="element-198" data-mp="y29xqmq6rsfo">Illustrative pre-show campaign</p></div>
              {[['Target attendees', '1,000'], ['Connections', '~310'], ['Qualified leads', '22'], ['Meetings', 'Before day one']].map(([label, value]) => <div key={label} className="flex items-baseline justify-between gap-6 border-b border-gray-800 px-6 py-5 last:border-b-0" data-id="element-199" data-mp="1hooatz3530j0">
                  <span className="font-medium text-gray-300" data-id="element-200" data-mp="1cr650hkf51f8">{label}</span>
                  <span className="text-right font-mono text-xl font-bold tabular-nums text-white" data-id="element-201" data-mp="1qoupvpehk8ka">{value}</span>
                </div>)}
            </div>
          </AnimatedSection>
        </div>
      </section>
    </>;
}